import React from "react";
import { Grid, Typography } from "@mui/material";
import { DEFAULT_FIELD_WIDTH, DEFAULT_LABEL_WIDTH } from "modules/topics/styles/constants";

interface IMandatoryField {
    fieldName: string;
    fieldInput: JSX.Element;
    labelWidth?: number;
    fieldWidth?: number;
    fieldStyle?: React.CSSProperties;
}

const MandatoryField: React.FunctionComponent<IMandatoryField> = (props) => {
    return (
        <React.Fragment>
            <Grid item xs={props?.labelWidth ?? DEFAULT_LABEL_WIDTH}>
                <Typography display={"inline"}>
                    {props.fieldName}
                </Typography>

                <Typography display={"inline"} className="red-text">
                    *
                </Typography>
            </Grid>

            <Grid item xs={props?.fieldWidth ?? DEFAULT_FIELD_WIDTH} style={props.fieldStyle}>
                {props.fieldInput}
            </Grid>

        </React.Fragment>
    );
};

export default MandatoryField;